import { Role } from 'src/graphql/generated/graphql';
import { FieldValues } from '@otp/ui';

export type LoginRuleCriteria = any;

export type SelectedRole = Pick<Role, 'name' | 'id'>;

export type Form = FieldValues & {
  name: string;
  description: string | undefined;
  acceptCriteria: LoginRuleCriteria[];
  exceptCriteria: LoginRuleCriteria[];
  rolesIncluded: SelectedRole[];
  rolesExcluded: SelectedRole[];
};

export enum LoginRuleCriteriaType {
  Include = '1',
  Exclude = '0',
}
